export default __webpack_public_path__ + "static/media/Smart_wall_switch_02.9305b8f6.svg";